export const BOOKMARK_ICONS: Record<string, string> = {
    'ventas':               'tags',
    'presupuestos':         'tags',
    'acopios':              'tags',
    'listas-de-precios':    'tags',
    'compras':              'cart3',
    'proveedores':          'cart3',
    'productos':            'box-seam',
    'categorias':           'hdd-stack',
    'stock':                'boxes',
    'envios':               'truck',
    'hojas-de-ruta':        'truck',
    'conductores':          'truck',
    'vehiculos':            'truck',
    'recepciones':          'stack',
    'retiros':              'stack',
    'preparacion-de-envios':'stack',
    'clientes':             'people-fill',
    'cuentas-corrientes':   'people-fill',
    'cuentas-corrientes/deudas': 'people-fill',
    'empleados':            'file-person',
    'salarios':             'file-person',
    'pagos':                'cash-stack',
    'pagos-pendientes':     'cash-stack',
    'cajas':                'wallet2',
    'cheques':              'wallet2',
    'tarjetas':             'wallet2',
    'transacciones':        'wallet2',
    'gastos':               'receipt',
    'tipos-de-gasto':       'receipt',
    'proveedores-de-gasto': 'receipt',
    'impuestos':            'coin',
    'medios-de-pago':       'person-badge',
    'ordenes-de-envio':     'truck',
    'ordenes-de-retiro':    'bag-fill',
    'ordenes-de-recepcion': 'cart-check',
}

export const BOOKMARK_LABELS: Record<string, string> = {
    'ventas': 'Ventas',
    'presupuestos': 'Presupuestos',
    'acopios': 'Acopios',
    'compras': 'Compras',
    'envios': 'Envíos',
    'preparacion-de-envios': 'Prep. Envíos',
    'stock': 'Stock',
    'clientes': 'Clientes',
    'proveedores': 'Proveedores',
    'productos': 'Productos',
    'hojas-de-ruta': 'Hojas de Ruta',
    'conductores': 'Conductores',
    'vehiculos': 'Vehículos',
    'empleados': 'Empleados',
    'gastos': 'Gastos',
    'recepciones': 'Recepciones',
    'retiros': 'Retiros',
    'pagos': 'Pagos',
    'cuentas-corrientes': 'Ctas Ctes',
    'cuentas-corrientes/deudas': 'Deudores',
    'cajas': 'Cajas',
    'categorias': 'Categorías',
    'listas-de-precios': 'Listas de Precios',
    'medios-de-pago': 'Medios de Pago',
    'impuestos': 'Impuestos',
    'cheques': 'Cheques',
    'tarjetas': 'Tarjetas',
    'transacciones': 'Transacciones',
    'tipos-de-gasto': 'Tipos de Gasto',
    'proveedores-de-gasto': 'Prov. de Gasto',
    'salarios': 'Salarios',
    'pagos-pendientes': 'Pagos Pendientes',
    'ordenes-de-envio': 'Envíos',
    'ordenes-de-retiro': 'Retiros',
    'ordenes-de-recepcion': 'Recepciones',
}
